module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-desktop@3x-5a62b12cbbf9fa8bbf58305f8717da62.jpg";